// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../../../../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../../../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.BWecVWMJWgE8qEohRHNq{grid-template-columns:60px 1fr 32px;align-items:flex-end;gap:12px;display:grid}.BWecVWMJWgE8qEohRHNq .pcYTuznskMCZMnXcnPxf{margin-bottom:4px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `BWecVWMJWgE8qEohRHNq`,
	"delete": `pcYTuznskMCZMnXcnPxf`
};
export default ___CSS_LOADER_EXPORT___;
